import { $color_grey_2, $color_grey_10, $color_grey_9, $color_brand_text_defalut, $color_grey_4, $color_grey_7, $color_grey_1, $color_brand_light_bg_default, $color_brand_light_bg_hover } from '../pebbleGlobalToken/color.js';
import { $font_size_2 } from '../pebbleGlobalToken/font.js';

/**
 * 表格-控制元素替代背景色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-2
 */
var $table_color_fill_alter = $color_grey_2;

/**
 * 表格-控制标题字体颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-10
 */
var $table_color_text_heading = $color_grey_10;

/**
 * 表格-字段颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $table_cell_color = $color_grey_9;

/**
 * 表格-字段大小。
 * @description enDesc: -
 * @description type: Font
 * @description value: $font-size-2
 */
var $table_cell_font_size = $font_size_2;

/**
 * 表格-操作颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_text_defalut
 */
var $table_cell_action_color = $color_brand_text_defalut;

/**
 * 表格-分割线颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-4
 */
var $table_color_border_secondary = $color_grey_4;

/**
 * 表格-分页默认文本
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-7
 */
var $table_pagination_color_text_default = $color_grey_7;

/**
 * 表格-排序状态下的td 背景色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-1
 */
var $table_body_sort_bg = $color_grey_1;

/**
 * 分页-颜色-背景-激活状态
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_light_bg_default
 */
var $table_pagination_color_bg_active = $color_brand_light_bg_default;

/**
 * 分页-颜色-背景激活状态下的-hover
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_light_bg_hover
 */
var $table_pagination_color_bg_active_hover = $color_brand_light_bg_hover;

/**
 * 分页-颜色-文本-hover
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_text_defalut
 */
var $table_pagination_color_text_hover = $color_brand_text_defalut;

export { $table_body_sort_bg, $table_cell_action_color, $table_cell_color, $table_cell_font_size, $table_color_border_secondary, $table_color_fill_alter, $table_color_text_heading, $table_pagination_color_bg_active, $table_pagination_color_bg_active_hover, $table_pagination_color_text_default, $table_pagination_color_text_hover };
